'use client'

import { useApiQuery } from '@/hooks/use-api'

export type BrandWorkspace = {
  id: string
  organizationId: string
  clerkOrgId: string
  slug: string
  name: string
  iconUrl: string | null
  completedBrandOnboarding: boolean
}

export const BRAND_WORKSPACES_API_PATH = '/api/brands/summary'
export const BRAND_WORKSPACES_QUERY: Record<string, string> = {
  include_icons: 'true',
}
export const BRAND_WORKSPACES_CACHE_KEY = ['/api/brands'] as const

/**
 * App-chrome brand/workspace list owner.
 *
 * The legacy cache key is retained while callers migrate from direct
 * `mutate(['/api/brands'])`; new call sites should refresh through this hook's
 * returned `mutate` function instead of importing SWR cache keys.
 */
export function useBrandWorkspaces() {
  return useApiQuery<BrandWorkspace[]>(BRAND_WORKSPACES_API_PATH, {
    query: BRAND_WORKSPACES_QUERY,
    cacheKey: BRAND_WORKSPACES_CACHE_KEY,
  })
}
